module.exports = require('./lib/axios');


//////////////////
// WEBPACK FOOTER
// ./~/axios/index.js
// module id = ./node_modules/axios/index.js
// module chunks = 88